import React from 'react';
import Component from '../../../ui-components/Component';
import Page from '../../../ui-components/Page';
import { withResizer, withTranslations } from '../../../HoCs';
import { isEmptyString, path } from '../../../utils';
import OTAFlow from '../Create/components/OTAFlow';
import pages, { getRouteForPage } from '../../../PageEnums';
import CyclicFooter from '../../../ui-components/Banners/CyclicFooter';
import Network, { forceLogout } from '../../../services/Network';
import { GET_SCRAPED_DETAILS } from '../../../utils/endpoints';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';

class PropertyAddOtaListing extends Component {
    
    translation_key = 'properties_translations';
    state={
        prefillOta:null
    };
    
    componentDidMount() {
        if (hmsSelfOnboardingEnabled()) forceLogout();
        else {
            const property_unique_id = path(this.props.match, 'params.id');
            if (!isEmptyString(property_unique_id)) {
                Network.GET(GET_SCRAPED_DETAILS, { property_unique_id }, null, response => {
                    this.setState({ prefillOta: response });
                });
            }
        }
    }
    
    render = () => {
        const property_unique_id = path(this.props.match, 'params.id');
        return <Page contentStyle={{ overflowY: 'none', position: 'relative' }}  renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
            <OTAFlow
                backRoute={getRouteForPage(pages.PROPERTIES, property_unique_id)}
                title='edit_property_information' className='fillSpace'
                id={property_unique_id}
                submitDialog={{ loadingText: 'updating_property_details', successText: 'property_details_updated', actionText: 'Back' }}
                finalPageRedirection={getRouteForPage(pages.PROPERTIES, property_unique_id)}
                prefillOta={this.state.prefillOta}
                gc={this.gc}
            />
            
        </Page>
    };


}

export default withTranslations(withResizer(PropertyAddOtaListing));
